import { render } from "./AddressSearchComponent.vue?vue&type=template&id=f5d557f2&ts=true"
import script from "./AddressSearchComponent?vue&type=script&lang=ts"
export * from "./AddressSearchComponent?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/xebel/xebel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__